// @flow

import type {
  EasyCompObject,
  EasyCompMap,
  EasyCompPure,
  EasyCompProps
} from '../../type'

import * as React from 'react'
import { Map, List } from 'immutable'
import { treeTypes } from '../comps'

export function convertMapToObject (easyCompMap: EasyCompMap): EasyCompObject {
  return new EasyCompClass(easyCompMap)
}

export function convertPureToMap (easyCompPure: EasyCompPure): EasyCompMap {
  let childrenProp = {}
  if (easyCompPure.children) {
    childrenProp = {
      children: List(easyCompPure.children.map(convertPureToMap))
    }
  }
  const compType = treeTypes[easyCompPure.type] || treeTypes.notSupport
  if (easyCompPure.props && easyCompPure.props.actions) {
    // $FlowFixMe
    const actions: Array<any> = compType.component.actions || []
    let mergeActions = [...actions]
    easyCompPure.props.actions.forEach(action => {
      if (actions.filter(item => item.name === action.name).length === 0) {
        mergeActions.push(action)
      }
    })
    // $FlowFixMe
    compType.component.actions = mergeActions
  }
  return Map({
    comp: compType.component,
    type: easyCompPure.type,
    id: easyCompPure.id,
    props: Map(easyCompPure.props),
    title: easyCompPure.title,
    refCompCode: easyCompPure.refCompCode,
    ...childrenProp
  })
}

export function getIteratorIndexId (index?: string) {
  return index == null ? '' : index.split(',').join('')
}

class EasyCompClass {
  easyCompMap: EasyCompMap;

  constructor (easyCompMap: EasyCompMap) {
    this.easyCompMap = easyCompMap
  }

  get id (): string {
    return this.easyCompMap.get('id')
  }

  get comp (): React.ComponentType<*> {
    return this.easyCompMap.get('comp')
  }

  get type (): string {
    return this.easyCompMap.get('type')
  }

  get props (): EasyCompProps {
    return this.easyCompMap.get('props', Map()).toJS()
  }

  get title (): string {
    return this.easyCompMap.get('title')
  }

  get children (): List<Map<*, *>> {
    return this.easyCompMap.get('children', List([]))
  }

  get refCompCode (): string {
    return this.easyCompMap.get('refCompCode')
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/util/index.js